if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.announcement = this.querySelector('.announcement');
      this.backgrounds = this.querySelectorAll('.announcement-bg');

      // Slideshow background/color transitions
      if (this.querySelectorAll('.slideshow__slide').length > 1) {
        const observer = new MutationObserver(this.mutationCallback.bind(this));
        const config = { attributes: true, attributeFilter: ['class'] };
        this.querySelectorAll('.slideshow__slide').forEach((el) => {
          observer.observe(el, config);
        });
      }

      // Generic dropdown helper
      const initDropdown = (container, getValueFromOption, inputName, formSelector) => {
        const btn = container.querySelector('.announcement__lang-btn');
        const list = container.querySelector('.announcement__lang-list');
        const form = container.closest(formSelector);

        if (!btn || !list) return;

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          if (!expanded) {
            this.querySelectorAll('.announcement__lang-btn').forEach((b) => {
              if (b !== btn) b.setAttribute('aria-expanded', 'false');
            });
            this.querySelectorAll('.announcement__lang-list').forEach((l) => {
              if (l !== list) l.classList.remove('is-open');
            });
          }
          btn.setAttribute('aria-expanded', String(!expanded));
          list.classList.toggle('is-open', !expanded);
        });

        list.querySelectorAll('.announcement__lang-option').forEach((option) => {
          option.addEventListener('click', () => {
            const value = getValueFromOption(option);
            if (!value || !form) return;
            const input = form.querySelector(`input[name="${inputName}"]`);
            if (input) input.value = value;
            form.submit();
          });
        });

        document.addEventListener('click', (e) => {
          if (!container.contains(e.target)) {
            btn.setAttribute('aria-expanded', 'false');
            list.classList.remove('is-open');
          }
        });
      };

      // Language switcher dropdown
      this.querySelectorAll('[data-announcement-lang]').forEach((container) => {
        initDropdown(container, (o) => o.dataset.locale, 'locale_code', '.announcement__lang-form');
      });

      // Currency switcher dropdown
      this.querySelectorAll('[data-announcement-currency]').forEach((container) => {
        initDropdown(container, (o) => o.dataset.country, 'country_code', '.announcement__currency-form');
      });
    }

    mutationCallback(mutationList) {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (mutation.target.classList.contains('is-active')) {
            this.setActiveSlide(mutation.target);
          }
        }
      }
    }

    setActiveSlide(slide) {
      if (this.announcement) {
        this.announcement.style.setProperty('--announcement-text-color', slide.dataset.textColor);
      }
      this.backgrounds.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === slide.dataset.index);
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
